export default __webpack_public_path__ + "static/media/template.c8851fdc.png";